<template>
  <div ref="articlesBlockRef">
    <LazySection
      :is-height-fixed="!isFetched"
      :placeholder-height="500"
    >
      <div
        v-if="articles?.length"
        class="wrap"
      >
        <ArticlesGrid
          class="articles"
          :articles="articles"
          :slug="slug"
          :location="location"
          :geo-object="geoObject"
          :default-sogu-fields="defaultSoguFields"
          sogu-page="listing"
          sogu-block="articles"
        />
      </div>
    </LazySection>
  </div>
</template>

<script setup lang="ts">
  import { ArticlesGrid } from '@experience/traveler-articles-package';
  import type { LocationType } from '@/entities/location';
  import type { ContextGeoSubject } from '@/shared/types/geography.ts';
  import type { CityInfo, CountryInfo, RegionInfo } from '@/shared/api/experience';
  import { computed, ref } from 'vue';
  import { useArticlesBlockInfo } from '@/widgets/articlesBlock/api/useArticlesBlockInfo.ts';
  import { useListingArticleScrollRestoration } from '@/widgets/articlesBlock/composables/useListingArticleScrollRestoration.ts';
  import { LazySection } from '@/shared/ui/LazySections';

  interface Props {
    location: LocationType;
    slug: string;
    defaultSoguFields: ContextGeoSubject;
    geoObject: CountryInfo | RegionInfo | CityInfo;
  }

  const props = defineProps<Props>();

  // Контейнер блока статей нужен для сохранения позиции перед переходом в статью.
  const articlesBlockRef = ref<HTMLElement | null>(null);

  const urlParam = computed(() => ({ [props.location]: props.slug }));
  const { articles, isFetched } = useArticlesBlockInfo(computed(() => urlParam.value));

  useListingArticleScrollRestoration({ containerRef: articlesBlockRef });
</script>

<style scoped lang="scss">
  @use '@experience/shared/dist/assets/adaptivity' as adaptivity;

  .articles {
    padding-top: 80px;

    &:last-child {
      padding-bottom: 0;
    }

    @include adaptivity.tablet {
      padding-top: 56px;
    }

    @include adaptivity.tablet {
      padding-top: 56px;
    }
  }
</style>
